import kModal from "./../modal"
window.kModal = kModal
